import { configureStore } from "@reduxjs/toolkit";
import roleReducer from './Role';
import presaVisioneReducer from './PresaVisione';

const ReduxStore = configureStore({
  reducer: {
    role: roleReducer,
    presaVisione: presaVisioneReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false
  })
});

export default ReduxStore;
